import epsClient from 'enrollment-platform/api/eps.client'

const BASE_PATH = '/api/v1/plan-overrides/settings/auto-approve'

export interface AutoApproveSettings {
  'plan-benefit': boolean
  location: boolean
  'smoker-rates': boolean
  'service-area': boolean
  'plans-rates': boolean
}

export type AutoApproveKey = keyof AutoApproveSettings

export interface AutoApproveResponse {
  enabled: boolean
}

export const getAutoApproveSettings =
  async (): Promise<AutoApproveSettings> => {
    const { data } = await epsClient.get<AutoApproveSettings>(BASE_PATH)
    return data
  }

export const updateAutoApproveSetting = async (
  key: AutoApproveKey,
  enabled: boolean
): Promise<AutoApproveResponse> => {
  const { data } = await epsClient.put<AutoApproveResponse>(
    `${BASE_PATH}/${key}`,
    { enabled }
  )
  return data
}
